import React, { useMemo, useState } from 'react'
import { Drawer, DatePicker, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'
import Creatable from 'react-select/creatable'
import Select from 'react-select'
import pluralize from 'pluralize'
import moment from 'moment'

import { AiFillDelete, AiOutlineDelete, AiOutlineDown } from 'react-icons/ai'

import { useToggle, usePet, server, useListData, normalize } from '../../modules'
// import InvoiceItem from './invoiceItem'
import POItem from './poItem'
import NewSupplier from './newSupplier'
import Datepicker from '../reusable/datePicker'

import dayjs from "dayjs"

const { TabPane } = Tabs

const NewPurchaseOrder = ({ supplier: supp, onClose, path }) => {
    const [item, setItems] = useState([])
    
    const [string, setString] = useState('')
    const [index, setIndex] = useState(0)
    const [supplier, setSupplier] = useState(supp ? { label: supp.name, value: supp._id, ...supp } : null)
    const [terms, setTerms] = useState()
    const [tnc, setTnc] = useState()
    const [date, setDate] = useState(moment())
    const [deliveryDate, setDeliveryDate] = useState()

    const history = useHistory()

    const [visible, toggleVisible] = useToggle(false)

    useMemo(() => setTimeout(toggleVisible, 100), [])

    let termOptions = [
        'Net 15',
        'Net 30',
        'Net 45',
        'Net 60',
        'Due on Receipt',
        'Due end of the month',
        'Due end of next month',
    ]

    const [
        { loading: supLoading, fetch: fetchSuppliers },
        { list: suppliers = [] }
    ] = useListData('suppliers', { string }, { notify: true })

    const searchSuppliers = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchSuppliers()
        }
    }

    const viewItem = i => {
        setIndex(i)
        setTimeout(() => history.push(`${path}/new/${i}`), 300)
    }

    const save = (val, i) => {  
        let temp = [...item]
        temp[i] = {
            ...temp[i],
            ...val
        }
        setItems(temp)
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }
    
    const onComplete = ({}, notif, ops) => {
        notif('Purchase order has been generated', ops('success'))
        onClose()
        close()
    }

    const removeItem = i => setItems(itms => itms.filter((_, x) => x !== i))

    const [{ loading: newLoading }, generatePO] = usePet('generatePurchaseOrder', {
        items: item.map(({ item, name, qty, unit, price, discount, vat }) => ({
            item: item?._id, 
            name, 
            quantity: qty, 
            unit, 
            vat, 
            discount, 
            unitPrice: price
        })),
        supplier: supplier?.value,
        details: {
            terms: terms?.value,
            date: date?._d,
            deliveryDate,
            tnc
        }
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Generating Purchase Order...' } })

    const [{ loading: newNCLoading }, generateAndApprove] = usePet('generateAndApprovePurchaseOrder', {
        items: item.map(({ _id, name, qty, unit, price, discount, vat }) => ({
            item: item?._id, 
            name, 
            quantity: qty, 
            unit, 
            vat, 
            discount, 
            unitPrice: price
        })),
        supplier: supplier?.value,
        details: {
            terms: terms?.value,
            date: date?._d,
            deliveryDate,
            tnc
        }
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Generating Purchase Order...' } })

    const getCount = itm => Number(itm?.bulk * itm?.contains) === Number(itm?.contains) ? Number(itm?.bulk * itm?.contains) : Number(itm?.bulk)

    const newItm = () => {
        setItems(itms => {
            return [
                ...itms,
                {
                    name: `Item ${item.length + 1}`,
                    unit: 'Units',
                    qty: 1,
                    discount: 0,
                    price: 1,
                    vat: 0
                }
            ]
        })
    }

    const disablePastDates = (currentDate) => {
        return currentDate && currentDate.isBefore(dayjs(), 'day');
      };

    return (
      <Drawer
        closable
        maskClosable
        visible={visible}
        onClose={close}
        footer={
          <div className="w-full text-right">
            <button
              className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              onClick={generateAndApprove}
            >
              Generate & Approve Purchase Order
            </button>
            <button
              className="text-white mr-2 hisani-btn-green font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              onClick={generatePO}
            >
              Generate Purchase Order
            </button>
          </div>
        }
        width="60%"
      >
        <p className="font-extrabold text-3xl mb-0">New Purchase Order</p>
        <div className="sm:flex justify-center items-center mb-2">
          <Creatable
            onCreateOption={() => history.push(`${path}/new/addSupplier`)}
            isLoading={supLoading}
            loadingMessage={(str) => `Searching for "${str?.inputValue}"`}
            className="min-w-56 mr-4"
            // styles={{ input: styles => ({ ...styles, minWidth: '25em' }) }}
            onInputChange={searchSuppliers}
            value={supplier}
            onChange={setSupplier}
            options={suppliers.map((supplier) => ({
              label: supplier.name,
              value: supplier._id,
            }))}
            placeholder="Search for Supplier"
          />
        </div>
        {supplier && (
          <Tabs>
            <TabPane tab="Items" key="1">
              {item?.length > 0 ? (
                <>
                  <table className="table-auto w-full">
                    {/* Table header */}
                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                      <tr>
                        <th className="p-2 pl-4 text-center">
                          <div className="font-semibold">No.</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold">Item</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold">Quantity</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold">Unit Price</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold">Discount</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold">VAT</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold">Total</div>
                        </th>
                        <th className="p-2 text-left">
                          <div className="font-semibold"></div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                      {item.map((itm, key) => (
                        <tr>
                          <td className="p-2 h-5 text-center">{key + 1}</td>
                          <td className="p-2 h-5">
                            <div className="">{itm?.name}</div>
                          </td>
                          <td className="p-2 h-5">
                            <div className="">
                              {Number(itm?.qty)}{" "}
                              {pluralize(itm?.unit, itm?.qty)}
                            </div>
                          </td>
                          <td className="p-2 h-5">
                            <div className="">Ksh. {itm?.price}</div>
                          </td>
                          <td className="p-2 h-5">
                            <div className="">Ksh. {itm?.discount}</div>
                          </td>
                          <td className="p-2 h-5">
                            <div className="">{itm?.vat}%</div>
                          </td>
                          <td className="p-2 h-5">
                            <div className="text-left">
                              Ksh. {normalize(itm?.qty * itm?.price)}
                            </div>
                          </td>
                          <td className="p-2 h-5">
                            <button
                              onClick={() => viewItem(key)}
                              className="btn py-1 shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                            >
                              View
                            </button>
                            <button
                              onClick={() => removeItem(key)}
                              className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text"
                            >
                              <AiOutlineDelete className="font-base" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="w-full py-5 text-center">
                    <button
                      onClick={newItm}
                      className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                    >
                      Add New Item
                    </button>
                  </div>
                  <div className="flex flex-col items-end pr-3 py-3">
                    <p className="font-semibold text-lg underline mb-2">
                      Overview
                    </p>
                      <p className="mb-1">Before Discount: Ksh. {normalize(item?.reduce((total, itm) => total + (itm?.price * itm?.qty), 0))}</p>
                      <p className="mb-1">Discount: Ksh. {normalize(item?.reduce((total, itm) => total + (itm?.discount * itm?.qty), 0))}</p>
                      <p className="mb-1">VAT: Ksh. {normalize(item?.reduce((total, itm) => total + (((itm?.price - itm?.discount) * itm?.qty) * (itm?.vat / 100)), 0))}</p>
                      <p className="mb-1">Total: Ksh. {normalize(item?.reduce((total, itm) =>total +(itm?.price - itm?.discount) * itm?.qty +(itm?.price - itm?.discount) *itm?.qty *(itm?.vat / 100),0))}
                    </p>
                  </div>
                </>
              ) : (
                <div className="w-full h-16 text-center">
                  <button
                    onClick={newItm}
                    className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text"
                  >
                    Add New Item
                  </button>
                </div>
              )}
            </TabPane>
            <TabPane tab="Additional Details" key="2">
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/2 px-3 mb-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-email"
                  >
                    Payment Terms
                  </label>
                  <Select
                    className="min-w-56 mr-4"
                    value={terms}
                    onChange={setTerms}
                    options={termOptions.map((term) => ({
                      label: term,
                      value: term,
                    }))}
                    placeholder="Select Payment Terms"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-username"
                  >
                    Purchase Order Date
                  </label>
                  <Datepicker
                    disabledDate={disablePastDates}
                    onChange={setDate}
                    value={date}
                    placeholder="Purchase Order Date"
                  />
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-email"
                  >
                    Expected Delivery Date
                  </label>
                  <Datepicker
                    disabledDate={disablePastDates}
                    onChange={setDeliveryDate}
                    value={deliveryDate}
                    placeholder="Expected Delivery Date"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-username"
                  >
                    Terms & Conditions
                  </label>
                  <textarea
                    value={tnc}
                    onChange={(e) => setTnc(e.target.value)}
                    rows="5"
                    name="terms"
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-username"
                    type="text"
                    placeholder="Terms & Conditions"
                  />
                </div>
              </div>
            </TabPane>
          </Tabs>
        )}
        <Switch>
          <Route path={`${path}/new/addSupplier`}>
            <NewSupplier
              string={string}
              onPerform={(x) => setSupplier({ label: x.name, value: x._id })}
            />
          </Route>
          <Route path={`${path}/new/:index`}>
            <POItem onSave={save} record={item[index]} />
          </Route>
        </Switch>
      </Drawer>
    );
}

export default NewPurchaseOrder